import { cn } from '@helpers/cn';

import { TProps } from './types/TProps';

export const EnvironmentBadge = ({ label, className }: TProps) => (
  <span aria-hidden="true" className={cn('env-badge', className)}>
    {label}
  </span>
);
